// Shared price maths for negotiated prices. Used by the Ex-GST Calculator tab and the
// "Negotiate price" dialog on the invoice form.

// Round to the nearest EVEN cent, exactly as the backend (Python) and the invoice form's
// round2 do — so the dialog preview always matches the saved invoice.
export const r2 = (n) => {
  const x = Number(n) || 0;
  if (!Number.isFinite(x)) return 0;
  const [intPart, frac = ""] = Math.abs(x).toFixed(20).split(".");
  const rest = frac.slice(2).replace(/0+$/, "");
  let cents = Number(intPart) * 100 + Number(frac.slice(0, 2).padEnd(2, "0"));
  if (rest === "5") cents += cents % 2 === 1 ? 1 : 0;
  else if (rest.startsWith("5") || rest > "5") cents += 1;
  return (x < 0 ? -cents : cents) / 100;
};

// GST exactly as the invoice computes it: GST = round(exGst * rate / 100).
export const gstOnEx = (exGst, gstRate = 10) =>
  r2(((Number(exGst) || 0) * (Number(gstRate) || 0)) / 100);

// The inc-GST total the invoice will actually show for a given ex-GST subtotal.
export const invoiceTotalFromEx = (exGst, gstRate = 10) =>
  r2((Number(exGst) || 0) + gstOnEx(exGst, gstRate));

// Split a GST-inclusive figure into the ex-GST + GST the invoice will actually use.
// Because GST is rounded per the invoice, a few inc-GST figures (~9%) cannot be hit to the
// cent; we pick the ex-GST whose invoice total is closest to the agreed price, preferring a
// total that is not above it (so the customer is never charged a cent more than agreed).
export function splitIncGst(incGst, gstRate = 10) {
  const agreed = r2(incGst);
  const rate = Number(gstRate) || 0;
  const base = r2(agreed / (1 + rate / 100));
  let best = null;
  for (let d = -3; d <= 3; d++) {
    const exGst = r2(base + d / 100);
    if (exGst < 0) continue;
    const total = invoiceTotalFromEx(exGst, rate);
    const diff = r2(total - agreed);
    const cand = { incGst: total, exGst, gst: gstOnEx(exGst, rate), diff };
    if (best === null) best = cand;
    else {
      const a = Math.abs(diff);
      const b = Math.abs(best.diff);
      if (a < b - 1e-9 || (Math.abs(a - b) < 1e-9 && diff < best.diff)) best = cand;
    }
  }
  return best || { incGst: agreed, exGst: base, gst: r2(agreed - base), diff: 0 };
}
